/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminProductDetailCategory
 */
export interface AdminProductDetailCategory {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailCategory
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailCategory
     */
    name: string;
}

export function AdminProductDetailCategoryFromJSON(json: any): AdminProductDetailCategory {
    return AdminProductDetailCategoryFromJSONTyped(json, false);
}

export function AdminProductDetailCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductDetailCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AdminProductDetailCategoryToJSON(value?: AdminProductDetailCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

